import { Skeleton } from '@mui/material';
import { useGetTableColumnsList } from '../api/dataCatalog/getTableColumns';
import { useEffect, useRef, useState } from 'react';
import ToolTip from '@/components/Tooltip';
import Checkbox from '@/components/Checkbox';
import { uniqBy } from 'lodash';

export const SourcesModalColumnList = ({
  tableId,
  sources,
  setSources,
  columns,
  setColumns,
  sourcesTableMapping,
  setSourcesTableMapping,
  // searchQuery,
  colRefetch,
  setColRefetch,
  tooltipShow,
  setTooltipShow,
  tableColumns,
  setTableColumns,
  tablesLoading,
  integrationsLoading,
  tableRefetch,
  currentColPageNumber,
  setCurrentColPageNumber,
  columnRef,
  immediateSearchQuery,
}) => {
  useEffect(() => {
    setCurrentColPageNumber(1);
  }, [immediateSearchQuery, tableId.id]);

  useEffect(() => {
    if (tableColumns.length > 0 && tableColumns[0].tableId !== tableId.id) {
      setTableColumns([]);
    } else {
      columnListData.refetch();
    }
  }, [tableId.id]);

  useEffect(() => {
    setColumns(sources[tableId.id]?.map((sel) => sel.name) || []);
  }, [tableId, sources]);

  useEffect(() => {
    if (colRefetch && tableColumns.length > 0) {
      setCurrentColPageNumber((prev) => prev + 1);
    }
  }, [colRefetch]);

  const columnListData = useGetTableColumnsList({
    tableId: tableId.id,
    // keyword: searchQuery,
    pageNumber: currentColPageNumber,
    config: {
      // staleTime: Infinity,
    },
  });

  useEffect(() => {
    if (
      columnListData.data?.data &&
      !columnListData.isLoading &&
      !tablesLoading &&
      !integrationsLoading
    ) {
      if (columnListData.data.data.length > 0) {
        setTableColumns((prev) => {
          let temp = structuredClone(prev || []);
          temp = [...temp, ...columnListData.data.data];
          temp = uniqBy(temp, (col) => col.name);
          return temp;
        });
        setColRefetch(false);
      }
    }
  }, [
    columnListData.data,
    columnListData.isLoading,
    integrationsLoading,
    tablesLoading,
    currentColPageNumber,
  ]);

  useEffect(() => {
    if (
      columnRef.current &&
      currentColPageNumber === 1 &&
      tableColumns.length > 0
    ) {
      const firstCol = columnRef.current.children[0];
      firstCol.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [tableColumns?.[0]?.tableId]);

  return (
    <>
      {tableColumns.length > 0 &&
      (!tablesLoading || (tableRefetch && tablesLoading)) ? (
        tableColumns.map((column, ind) => {
          return (
            <div className="flex flex-col w-full" onClick={() => {}}>
              {ind > 0 && (
                <span
                  className="w-full bg-pv-neutral-grey-100 px-2"
                  style={{
                    height: '1px',
                  }}
                ></span>
              )}
              <div
                className={`flex items-center cursor-pointer hover:bg-pv-primary-primary-50 justify-between col-el`}
                key={ind}
                style={{
                  height: '45px',
                }}
              >
                <Checkbox
                  label={
                    <div className="flex gap-1.5 items-center ">
                      <div className="flex items-center">
                        <ToolTip
                          placement="top"
                          title={column.label}
                          tooltipActive={tooltipShow}
                          displayTooltipOnOverflow
                        >
                          <span
                            onMouseEnter={() => {
                              setTooltipShow(true);
                            }}
                            className="col-txt overflow-hidden whitespace-nowrap overflow-ellipsis"
                            style={{
                              maxWidth: '140px',
                            }}
                          >
                            {column.label}
                          </span>
                        </ToolTip>
                      </div>
                      <div className="flex items-center bg-pv-primary-primary-100 px-1.5 py-0.5 text-xs rounded-lg">
                        <div className="flex items-center">
                          <ToolTip
                            placement="top"
                            title={column.name}
                            tooltipActive={tooltipShow}
                            displayTooltipOnOverflow
                          >
                            <span
                              onMouseEnter={() => {
                                setTooltipShow(true);
                              }}
                              className="col-txt overflow-hidden whitespace-nowrap overflow-ellipsis"
                              style={{
                                maxWidth: '100px',
                              }}
                            >
                              {column.name}
                            </span>
                          </ToolTip>
                        </div>
                      </div>
                    </div>
                  }
                  checked={columns.includes(column.name)}
                  className={{
                    wrapper:
                      'px-4 py-3 w-full flex gap-2 items-center hover:bg-pv-primary-primary-50 cursor-pointer',
                  }}
                  onChange={() => {
                    let temp = structuredClone(sources || {});
                    let tempMapping = structuredClone(
                      sourcesTableMapping || {}
                    );
                    if (columns.includes(column.name)) {
                      temp[tableId.id] = temp[tableId.id].filter(
                        (col) => col.name !== column.name
                      );
                      if (temp[tableId.id].length === 0) {
                        delete tempMapping[tableId.id];
                      }
                    } else {
                      if (temp[tableId.id] === undefined) {
                        temp[tableId.id] = [];
                      }
                      tempMapping[tableId.id] = tableId;
                      temp[tableId.id].push({
                        ...column,
                        tableDetails: { ...tableId, maps: [] },
                      });
                    }
                    if (Array.isArray(Object.keys(temp))) {
                      Object.keys(temp).forEach((src) => {
                        temp[src] = temp[src].sort((a, b) =>
                          a.name.localeCompare(b.name)
                        );
                      });
                    }
                    setSources(temp);
                    setSources(temp);
                    setSourcesTableMapping(tempMapping);
                  }}
                />
              </div>
            </div>
          );
        })
      ) : columnListData?.isLoading || tablesLoading || integrationsLoading ? (
        <div className="w-full flex flex-col gap-5 p-2">
          {Array.from({ length: 10 }).map((_, index) => (
            <div className="flex gap-2 py-1" key={index}>
              <Skeleton
                variant="rounded"
                width={20}
                height={20}
                sx={{ bgcolor: '#EEF0F7' }}
              />
              <Skeleton
                variant="rounded"
                width={index % 2 === 1 ? '30%' : '60%'}
                height={20}
                sx={{ bgcolor: '#EEF0F7' }}
              />
            </div>
          ))}
        </div>
      ) : (
        <span className="w-full text-pv-text-secondary-text text-xs">
          No Columns Found
        </span>
      )}
    </>
  );
};
